import React, { useContext } from "react";
import { Button, Card, Col, Form, Input, Row } from "antd";
import { AuthContext } from "../context/AuthState";
import keosLogo from "../assets/images/KeosPng.png";
import requests from "../lib/requests";
import { useNavigate } from "react-router-dom";
import googleLogo from "../assets/svg/google.svg";
import { NotificationContext } from "../context/NotificationProvider";

type FieldType = {
  email?: string;
  password?: string;
};

const Login: React.FC = () => {
  const { setMessage } = useContext(NotificationContext);
  const { setUser, logOut } = React.useContext(AuthContext);
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      console.log("clicked", values);
      const resData = await (
        await requests.post("/auth/login", {
          ...values,
        })
      ).data;

      if (!resData.data.token) {
        throw new Error();
      }
      await setUser(resData.data);
      navigate("/");
    } catch (error: any) {
      console.log(error, " the error ");
      setMessage({
        message: "Credencial inválida",
        className: "failedRequest",
      });
      await logOut();
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    setMessage({
      className: "failedRequest",
      message: "Error",
    });
    console.log("Failed:", errorInfo);
  };

  return (
    <Col>
      <Row
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Col>
          <Row justify={"center"}>
            <img src={keosLogo} alt="keos" />
          </Row>
          <Card style={{ minWidth: "500px" }}>
            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ maxWidth: 600 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item<FieldType>
                label="Correo electrónico"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "¡Por favor ingrese su correo electrónico!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item<FieldType>
                label="Contraseña"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "¡Por favor ingrese su contraseña!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit">
                  Iniciar sesión
                </Button>
              </Form.Item>
            </Form>
          </Card>
          <Row style={{ flex: 1, justifyContent: "center", padding: "20px" }}>
            <a
              href="/auth/google"
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "20px",
                fontWeight: "bold",
                gap: "10px",
                background: "#fff",
                padding: "10px",
                justifyContent: "center",
                borderRadius: "10px",
              }}
            >
              <img src={googleLogo} width={"40px"} height={"40px"} />{" "}
              <span>Inicia sesión con Google</span>
            </a>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default Login;
